(function () {
  var CARET_SVG = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>';
  var ARROW_SVG = '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg>';

  // MenuDrawer.bindEvents() runs at constructor time and misses dynamically injected summaries.
  // We replicate onSummaryClick behaviour via delegation for BH-injected sub-summaries.
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.bh-drawer-sub-summary');
    if (!summary) return;
    var details = summary.parentNode;
    if (!details || details.tagName !== 'DETAILS') return;
    // Native <details> toggle already happened; add menu-opening so CSS shows the panel.
    setTimeout(function () {
      if (!details.hasAttribute('open')) return;
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
      var parentHasSubmenu = details.closest('.has-submenu');
      if (parentHasSubmenu) parentHasSubmenu.classList.add('submenu-open');
      // trapFocus keeps activeElement inside header-drawer, preventing MenuDrawer.onFocusOut
      // from firing closeMenuDrawer() which would strip 'open' from all inner details.
      var subDiv = details.querySelector('.menu-drawer__submenu');
      var closeButton = subDiv && subDiv.querySelector('button');
      if (subDiv && closeButton) {
        if (typeof trapFocus === 'function') {
          trapFocus(subDiv, closeButton);
        } else {
          closeButton.focus();
        }
      }
    }, 100);
  });

  // Delegated close handler — mirrors MenuDrawer.closeSubmenu / closeAnimation.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bh-drawer-close');
    if (!btn) return;
    var details = btn.closest('details');
    if (!details) return;
    var parentSubmenuOpen = details.closest('.submenu-open');
    if (parentSubmenuOpen) parentSubmenuOpen.classList.remove('submenu-open');
    details.classList.remove('menu-opening');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    setTimeout(function () { details.removeAttribute('open'); }, 400);
  });

  function buildLookup(data) {
    var lookup = {};
    var keys = Object.keys(data);
    for (var i = 0; i < keys.length; i++) {
      var e = data[keys[i]];
      if (e && e.handle) lookup[e.handle] = e;
    }
    return lookup;
  }

  function sortedChildren(entry, lookup) {
    if (!entry || !entry.childs || !entry.childs.length) return [];
    return entry.childs
      .map(function (c) { return lookup[c.handle] || c; })
      .filter(function (c) { return c && c.display !== false; })
      .sort(function (a, b) {
        var ta = a.title.toLowerCase(), tb = b.title.toLowerCase();
        return ta < tb ? -1 : ta > tb ? 1 : 0;
      });
  }

  function revertToLink(container) {
    var isDrawer = container.classList.contains('bh-lvl3-drawer');
    var isCurrent = container.getAttribute('data-bh-current') === 'true';
    var a = document.createElement('a');
    a.id = container.id
      .replace('Details-HeaderSubMenu-', 'HeaderMenu-')
      .replace('Details-menu-drawer-', 'HeaderDrawer-');
    a.href = container.getAttribute('data-bh-url') || '#';
    a.textContent = container.getAttribute('data-bh-title') || '';
    if (isCurrent) a.setAttribute('aria-current', 'page');
    if (isDrawer) {
      a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset' +
        (isCurrent ? ' menu-drawer__menu-item--active' : '');
    } else {
      a.className = 'header__menu-item list-menu__item link link--text focus-inset caption-large' +
        (isCurrent ? ' list-menu__item--active' : '');
    }
    container.replaceWith(a);
  }

  // --- Desktop recursive fill ---

  function buildDesktopSubDetails(entry, children, lookup) {
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    summary.className = 'header__menu-item link link--text list-menu__item focus-inset caption-large';
    var span = document.createElement('span');
    span.textContent = entry.title;
    summary.appendChild(span);
    summary.insertAdjacentHTML('beforeend', CARET_SVG);
    details.appendChild(summary);

    var ul = document.createElement('ul');
    ul.className = 'header__submenu list-menu motion-reduce';
    ul.setAttribute('role', 'list');
    appendDesktopItems(ul, children, lookup, entry);
    details.appendChild(ul);
    return details;
  }

  function appendDesktopItems(ul, children, lookup, parentEntry) {
    var liAll = document.createElement('li');
    var aAll = document.createElement('a');
    aAll.href = '/collections/' + parentEntry.handle;
    aAll.className = 'header__menu-item list-menu__item link link--text focus-inset caption-large bh-nav-see-all';
    aAll.textContent = 'Voir tout';
    liAll.appendChild(aAll);
    ul.appendChild(liAll);

    children.forEach(function (c) {
      var li = document.createElement('li');
      var subchildren = sortedChildren(c, lookup);
      if (subchildren.length > 0) {
        li.appendChild(buildDesktopSubDetails(c, subchildren, lookup));
      } else {
        li.setAttribute('data-bh-check', c.handle);
        var a = document.createElement('a');
        a.href = '/collections/' + c.handle;
        a.className = 'header__menu-item list-menu__item link link--text focus-inset caption-large';
        a.textContent = c.title;
        li.appendChild(a);
      }
      ul.appendChild(li);
    });
  }

  function fillDesktop(container, children, lookup, parentUrl) {
    var ul = container.querySelector('ul');
    if (!ul) return;
    var parentEntry = { handle: container.getAttribute('data-bh-handle') };
    appendDesktopItems(ul, children, lookup, parentEntry);
  }

  // --- Drawer recursive fill ---

  function buildDrawerSubDetails(entry, children, lookup) {
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    // bh-drawer-sub-summary triggers our delegated open handler above
    summary.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset bh-drawer-sub-summary';
    summary.textContent = entry.title;
    summary.insertAdjacentHTML('beforeend', ARROW_SVG + CARET_SVG);
    details.appendChild(summary);

    var div = document.createElement('div');
    div.className = 'menu-drawer__submenu has-submenu gradient motion-reduce';
    div.setAttribute('tabindex', '-1');

    var inner = document.createElement('div');
    inner.className = 'menu-drawer__inner-submenu';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'menu-drawer__close-button bh-drawer-close link link--text focus-inset';
    closeBtn.setAttribute('aria-expanded', 'true');
    closeBtn.insertAdjacentHTML('afterbegin', ARROW_SVG);
    closeBtn.appendChild(document.createTextNode(' ' + entry.title));
    inner.appendChild(closeBtn);

    var ul = document.createElement('ul');
    ul.className = 'menu-drawer__menu list-menu';
    ul.setAttribute('role', 'list');
    ul.setAttribute('tabindex', '-1');
    appendDrawerItems(ul, children, lookup, entry);
    inner.appendChild(ul);

    div.appendChild(inner);
    details.appendChild(div);
    return details;
  }

  function appendDrawerItems(ul, children, lookup, parentEntry) {
    var liAll = document.createElement('li');
    var aAll = document.createElement('a');
    aAll.href = '/collections/' + parentEntry.handle;
    aAll.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset bh-nav-see-all';
    aAll.textContent = 'Voir tout';
    liAll.appendChild(aAll);
    ul.appendChild(liAll);

    children.forEach(function (c) {
      var li = document.createElement('li');
      var subchildren = sortedChildren(c, lookup);
      if (subchildren.length > 0) {
        li.appendChild(buildDrawerSubDetails(c, subchildren, lookup));
      } else {
        li.setAttribute('data-bh-check', c.handle);
        var a = document.createElement('a');
        a.href = '/collections/' + c.handle;
        a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
        a.textContent = c.title;
        li.appendChild(a);
      }
      ul.appendChild(li);
    });
  }

  function fillDrawer(container, children, lookup, parentUrl) {
    var ul = container.querySelector('.menu-drawer__menu');
    if (!ul) return;
    var parentEntry = { handle: container.getAttribute('data-bh-handle') };
    appendDrawerItems(ul, children, lookup, parentEntry);
  }

  // --- Empty collection check ---

  function checkEmptyCollections() {
    var CACHE_KEY = 'bh_nonempty';
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) {}

    var allItems = document.querySelectorAll('li[data-bh-check]');
    var handlesNeeded = {};
    allItems.forEach(function (li) {
      var h = li.getAttribute('data-bh-check');
      if (h && !(h in cache)) handlesNeeded[h] = true;
    });

    var handles = Object.keys(handlesNeeded);

    function applyAndSave() {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
      allItems.forEach(function (li) {
        var h = li.getAttribute('data-bh-check');
        if (h && cache[h] === false) li.remove();
      });
    }

    if (!handles.length) { applyAndSave(); return; }

    var remaining = handles.length;
    handles.forEach(function (handle) {
      fetch('/collections/' + handle + '/products.json?limit=1')
        .then(function (r) { return r.json(); })
        .then(
          function (data) { cache[handle] = !!(data.products && data.products.length); },
          function ()     { cache[handle] = true; }
        )
        .then(function () {
          remaining--;
          if (remaining === 0) applyAndSave();
        });
    });
  }

  // --- Main entry point ---

  function run() {
    if (typeof menuBhData === 'undefined') { console.warn('[BH] menuBhData undefined'); return; }
    var lookup = buildLookup(menuBhData);

    document.querySelectorAll('.bh-lvl3-container').forEach(function (container) {
      var handle = container.getAttribute('data-bh-handle');
      var url = container.getAttribute('data-bh-url') || ('/collections/' + handle);
      var entry = handle && lookup[handle];
      var children = entry ? sortedChildren(entry, lookup) : [];

      if (!entry) {
        revertToLink(container);
        return;
      }

      if (!children.length) {
        revertToLink(container);
        return;
      }

      if (container.classList.contains('bh-lvl3-drawer')) {
        fillDrawer(container, children, lookup, url);
      } else {
        fillDesktop(container, children, lookup, url);
      }
    });
  }

  function trigger() {
    if (typeof menuBhData === 'undefined') return;
    run();
    checkEmptyCollections();
  }

  document.addEventListener('DOMContentLoaded', function () {
    trigger();
  });

  // Si bh_menu_arbo.js est chargé en lazy (cf. theme.liquid), il dispatche
  // cet évènement après injection de menuBhData. On re-tourne pour remplir
  // les .bh-lvl3-container qui étaient vides au DOMContentLoaded.
  window.addEventListener('bh-menu-data-ready', trigger);
})();
